// extracted by mini-css-extract-plugin
export default {"container":"styles_container__k0OTz","titleContainer":"styles_titleContainer__5qfHz","title":"styles_title__Cc5AK","list":"styles_list__Kl6-W","progress":"styles_progress__VgqCi"};